import {getMessages} from 'app/store/constants';

export const COPY_SECTION_TITLE = getMessages().getText('board_settings.actions.copy');
